module.exports = __webpack_public_path__ + "img/mgd.5743e355.jpg";